import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { MercuryService } from '../service/mercury.service';
import { StoryBlokService } from '../service/storyblok.service';
import { ThemeService } from '../service/theme.service';
import { ResolverErrorService } from './resolver-error.service';

@Injectable({ providedIn: 'root' })
export class StoryblokPersonaliserProductResolver implements Resolve<any> {
  constructor(
    private storyBlokService: StoryBlokService,
    private mercuryService: MercuryService,
    private themeService: ThemeService,
    private resolverError: ResolverErrorService
  ) {}

  async resolve(route: ActivatedRouteSnapshot) {
    const handle = route.paramMap.get('handle') as string;
    const fail = (err: unknown): never => {
      this.resolverError.handle(err);
      throw new Error('Not Found');
    };

    const page = await this.storyBlokService
      .getStory('personaliser-product/' + handle, {
        resolve_relations: ['personaliser-entry.config'],
      })
      .then((result) => {
        this.themeService.viewPage(result);
        const title =
          result?.story?.content?.metatags?.title || result.story.name;
        const description = result?.story?.content?.metatags?.description;
        return {
          ...result,
          seo: { title, description },
        };
      })
      .catch(fail);

    const [product, personalisation] = await Promise.all([
      lastValueFrom(this.mercuryService.getProductByHandle(handle)).catch(
        fail
      ),
      lastValueFrom(
        this.mercuryService.getProductByHandle('personalisation')
      ).catch(fail),
    ]);

    return {
      page,
      seo: page.seo,
      product,
      personalisation,
    };
  }
}
